import FilterPlaceholder from './FilterPlaceholder';
export default FilterPlaceholder;